import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  useMediaQuery,
} from "@mui/material";
import ClientReportView from "./ClientReport";
import CandidateReportView from "./CandidateReport";
import StaffReportView from "./StaffReport";
import JobReportView from "./JobReport";
import SystemReportView from "./SystemReport";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import CancelIcon from "@mui/icons-material/Cancel";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import WebAssetOffIcon from "@mui/icons-material/WebAssetOff";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import GroupIcon from "@mui/icons-material/Group";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import WorkIcon from "@mui/icons-material/Work";
import PostAddIcon from "@mui/icons-material/PostAdd";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import DomainAddIcon from "@mui/icons-material/DomainAdd";

const tabLabels = [
  "Clients",
  "Candidates",
  "Jobs",
  "Staffs",
  // "System",
];

const Reports = () => {
  const currentYear = new Date().getFullYear().toString();

  const [clientYear, setClientYear] = useState(currentYear);
  const [jobYear, setJobYear] = useState(currentYear);

  const [yearOptions, setYearOptions] = useState([]);

  // Client     
  const [clientStatData, setclientStatData] = useState([
    { title: "Total Clients", value: 0 },
    { title: "Active Clients", value: 0 },
    { title: "Inactive Clients", value: 0 },
  ]);
  const [mostCandidateDeployed, setMCD] = useState();
  const [topClients, setTopClients] = useState([]);

  // Candidate 
  const [candidateStatData, setCandidateStatData] = useState([]);
  const [candidateProcessData, setCandidateProcessData] = useState([]);

  const [countriesInProgress, setCountriesInProgress] = useState([]);
  const [depoyedByCountry, setDepoyedByCountry] = useState([]);
  const [professionStats, setProfessionStats] = useState([]);

  const [JobList, setJobList] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  const [processList, setProcessList] = useState([]);
  const [processName, setProcessName] = useState(null);
  const [candidateProcessName, setcandidateProcessName] = useState(null);

  // Staff Data
  const [staffList, setStaffList] = useState([]);

  const [cancellationRateStaff, setCancellationRateStaff] = useState("");
  const [offerStatusStaff, setOfferStatusStaff] = useState("");
  const [candidateByStaff, setcandidateByStaff] = useState("");
  const [interviewScheduledStaff, setInterviewScheduledStaff] = useState("");
  const [recruitmentProcessStaff, setrecruitmentProcessStaff] = useState("");



  const [startDate, setStartDate] = useState(""); // staff
  const [endDate, setEndDate] = useState(""); // staff

  const [recruitmentProcessStartDate, setRecruitmentProcessStartDate] = useState("");
  const [endDate1, setEndDate1] = useState("");

  const [interviewStats, setInterviewStats] = useState([]);

  // Staff       
  const [staffProcessStats, setStaffProcessStats] = useState([]);
  const [recruitmentStage, setRecruitmentStage] = useState("");
  const [candidateRecruitmentStage, setCandidateRecruitmentStage] = useState("");

  const [RecruitmentStageslist, setRecruitmentStageslist] = useState([]);
  const [staffInterviewScheduledList, setStaffInterviewScheduledList] = useState([]);
  const [staffCancelRate, setStaffCancelRate] = useState({});
  const [staffOfferStats, setStaffOfferStats] = useState({});
  const [candidateByStaffList, setCandidateByStaffList] = useState();

  const [statusList, setStatusList] = useState([]);
  const [interviewStatus, setInterviewStatus] = useState("");

  // Job          
  const [jobStatData, setJobStatData] = useState([]);
  const [jobPostStats, setJobPostStats] = useState([]);
  const [jobProfStats, setJobProfStats] = useState([]);
  const [jobClientStats, setJobClientStats] = useState([]);
  const [NewClientData, setNewClientData] = useState([]);
  const [jobApplicationData, setJobApplicationData] = useState([]);
  const [deployedJobStats, setDeployedJobStats] = useState([]);

  // Tab 
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Client API   
  const getClientData = async () => {
    await axiosAPI
      ?.get(`/reports/Clientcount`)
      .then((res) => {
        const apiData = res?.data?.data;
        // console.log(res?.data?.data,'getClientData');


        if (apiData) {
          const colors = [
            "#D6ECFF", // Light Blue
            "#E4F9E3", // Light Green
            "#FFEBCB", // Light Orange
            "#DEE5FF", // Soft Indigo
            "#FFD6D6", // Light Rose
            "#D4F1FF", // Ice Blue
            "#E3EEFF", // Pale Sky
            "#F0DEFF", // Light Lavender
            "#E9F8E5", // Minty Green
            "#FFDFF0", // Baby Pink
          ];

          const updatedclientStatData = [
            {
              title: "Total Clients",
              value: apiData.totalClients,
              Icon: <PeopleIcon />,
            },
            {
              title: "Active Clients",
              value: apiData.activeClients,
              Icon: <PersonIcon />,
            },
            {
              title: "Inactive Clients",
              value: apiData.inactiveClients,
              Icon: <PersonOffIcon />,
            },
          ].map((stat, index) => ({
            ...stat,
            color: colors[index % colors.length],
          }));

          setclientStatData(updatedclientStatData || []);
        }

      })
      .catch((err) => { });

    await axiosAPI
      ?.get(`/reports/deployed-client-stats`)
      .then((res) => {
        const apiData = res?.data?.data || [];
        setMCD(apiData);
      })
      .catch((err) => { });
  };

  const getClientJobPosted = async () => {
    if (!clientYear) {
      setNewClientData([])
      return
    }
    await axiosAPI
      ?.post(`/reports/new-client/quarter`, {
        year: clientYear,
      })
      .then((res) => {
        setNewClientData(res?.data?.data || []);
      })
      .catch((err) => { });
  };

  const getTopClients = async () => {
    await axiosAPI
      ?.get(`/reports/Top-clients`)
      .then((res) => {
        setTopClients(res?.data?.data || []);
      })

      .catch((err) => { });
  };

  const getStaff = async () => {
    try {
      const res = await axiosAPI.get(`/Employee/reportingstaff`);
      setStaffList(res?.data?.data || []);

      // const [cancellationRateStaff, setCancellationRateStaff] = useState(""); 
      // const [offerStatusStaff, setOfferStatusStaff] = useState("");
      // const [candidateByStaff, setcandidateByStaff] = useState("");
      // const [interviewScheduledStaff, setInterviewScheduledStaff] = useState("");
      // const [recruitmentProcessStaff, setrecruitmentProcessStaff] = useState("");

      setCancellationRateStaff(res?.data?.data[0]?.ED_Id)
      setOfferStatusStaff(res?.data?.data[0]?.ED_Id)
      setcandidateByStaff(res?.data?.data[0]?.ED_Id)
      setInterviewScheduledStaff(res?.data?.data[0]?.ED_Id)
      setrecruitmentProcessStaff(res?.data?.data[0]?.ED_UserLoginId)




    } catch (err) {
      console.error(err);
    }
  };

  // Candidate API 
  const getCandidateStats = async () => {
    try {
      const [
        summaryRes,
        delayRes,
        selectionRes,
        docSubRateRes,
        offerAcceptanceRate,
        cancellationRate,
      ] = await Promise.all([
        axiosAPI.get(`/reports/Candidate-summary`),
        axiosAPI.get(`/reports/candidate-deploymentdelay`),
        axiosAPI.get(`/reports/candidate-selection`),
        axiosAPI.get(`/reports/Document-submission-rate`),
        axiosAPI.get(`/reports/offer-acceptance-rate`),
        axiosAPI.get(`/reports/cancellation-rate`),
      ]);
      // console.log('______________________Candidate api data_____________________');

      const delayData = delayRes?.data?.data;
      // console.log(delayData,'delayData');

      const summaryData = summaryRes?.data?.data;
      // console.log(summaryData,'summaryData');

      const selectionData = selectionRes?.data?.data;
      // console.log(selectionData,'selectionData');

      const docSubRateData = docSubRateRes?.data?.data;
      // console.log(docSubRateData,'docSubRateData');

      const offerAcceptanceData = offerAcceptanceRate?.data?.data;
      // console.log(offerAcceptanceData,'offerAcceptanceData');

      const cancellationData = cancellationRate?.data?.data;
      // console.log(cancellationData,'cancellationData');


      if (summaryData && delayData) {
        const colors = [
          "#D6ECFF", // Light Blue
          "#E4F9E3", // Light Green
          "#FFEBCB", // Light Orange
          "#DEE5FF", // Soft Indigo
          "#FFD6D6", // Light Rose
          "#D4F1FF", // Ice Blue
          "#E3EEFF", // Pale Sky
          "#F0DEFF", // Light Lavender
          "#E9F8E5", // Minty Green
          "#FFDFF0", // Baby Pink
        ];


        const newStats = [
          {
            title: "Total Applications",
            value: summaryData?.TotalJobApplications,
            Icon: <PeopleIcon />,
          },
          {
            title: "Total Cancelled",
            value: cancellationData?.CancelledApplications,
            Icon: <CancelIcon />,
          },
          {
            title: "Total Deployed",
            value: summaryData?.HiredCandidates,
            Icon: <FlightTakeoffIcon />,
          },
          {
            title: "Average Time to Deploy",
            value: delayData?.avgDelayInDays
              ? `${parseInt(Number(delayData?.avgDelayInDays))} days`
              : delayData?.avgDelayInDays,
            Icon: <HourglassEmptyIcon />,
          },
          {
            title: "Candidates With Web Access",
            value: summaryData?.CandidateWithWebAccess,
            Icon: <WebAssetIcon />,
          },
          {
            title: "Candidates Without Web Access",
            value: summaryData?.CandidateWithoutWebAccess,
            Icon: <WebAssetOffIcon />,
          },
          {
            title: "Selection Rate",
            value: selectionData?.SelectionPercentage
              ? `${parseInt(Number(selectionData?.SelectionPercentage))}%`
              : selectionData?.SelectionPercentage,
            Icon: <TrendingUpIcon />,
          },
          {
            title: "Document Submission Rate",
            value: docSubRateData?.DocumentSubmissionPercentage
              ? `${parseInt(
                Number(docSubRateData?.DocumentSubmissionPercentage)
              )}%`
              : docSubRateData?.DocumentSubmissionPercentage,
            Icon: <UploadFileIcon />,
          },
          {
            title: "Offer Accept Rate",
            value: offerAcceptanceData?.OfferAcceptanceRate
              ? `${parseInt(Number(offerAcceptanceData?.OfferAcceptanceRate))}%`
              : offerAcceptanceData?.OfferAcceptanceRate,
            Icon: <ThumbUpIcon />,
          },
          {
            title: "Cancellation Rate",
            value: cancellationData?.CancellationRate
              ? `${parseInt(Number(cancellationData?.CancellationRate))}%`
              : cancellationData?.CancellationRate,
            Icon: <ThumbDownIcon />,
          },
        ].map((stat, index) => ({
          ...stat,
          color: colors[index % colors.length],
        }));
        setCandidateStatData(newStats); // set all 5 at once
      }
    } catch (err) {
      console.error("Error fetching candidate stats:", err);
    }
  };

  const getCountriesInProgress = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/country-inprogress`);
      setCountriesInProgress(res?.data?.data);
    } catch (err) { }
  };

  const getCountriesDeployed = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/country-deployed`);
      setDepoyedByCountry(res?.data?.data);
    } catch (err) { }
  };

  const getProfessionStats = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/profession-stats`);
      setProfessionStats(res?.data?.data);
    } catch (err) { }
  };

  const getJobs = async () => {
    try {
      const res = await axiosAPI?.get(`/Job/active/list`);
      const jobs = res?.data?.data || [];

      const jobListWithAll = [{ JD_Title: "All Jobs", JD_Id: null }, ...jobs];

      setJobList(jobListWithAll);
    } catch (err) { }
  };

  const getRecruitmentProcedurelist = async () => {
    try {
      const res = await axiosAPI.get(`/RecruitmentProcedure/list`);
      setProcessList(res?.data?.data || []);
      setProcessName(res?.data?.data[0]?.RP_Id);
      setcandidateProcessName(res?.data?.data[0]?.RP_Id);

    } catch (err) {
      console.error(err);
    }
  };

  const getInterviewStats = async () => {
  
    try {
      const res = await axiosAPI?.post(`/reports/interview-stats`, {
        job: selectedJob,
      });

      setInterviewStats(res?.data?.data);
    } catch (err) { }
  };

  const getCandidateProcess = async () => {
    try {
      const res = await axiosAPI?.post(`/reports/candidate-process`, {
        RP_Id: candidateProcessName,

        Startdate: recruitmentProcessStartDate ? recruitmentProcessStartDate : null,
        endDate: endDate1 ? endDate1 : null,
        Stage_id: candidateRecruitmentStage ? candidateRecruitmentStage : null,
      });

      setCandidateProcessData(res?.data?.data);
    } catch (err) {
      setCandidateProcessData([]);
    }
  };

  // Jobs API  
  const getJobData = async () => {
    try {
      const [
        jobSummaryRes,
        jobFullfillmentRes,
        interviewRateRes,
        offeracceptRes,
        cancelOpenVacancyRes,
      ] = await Promise.all([
        axiosAPI.get(`/reports/job-summary`),
        axiosAPI.get(`/reports/job-fullfillment`),
        axiosAPI.get(`/reports/interview-rate`),
        axiosAPI.get(`/reports/offeraccept-by-rejected`),
        axiosAPI.get(`/reports/Cancelled-openvaccancies`),
      ]);
      // console.log('__________________________Job api data_____________________');

      const JobSummaryData = jobSummaryRes?.data?.data;
      // console.log(JobSummaryData, 'JobSummaryData');

      const jobFullfillmentData = jobFullfillmentRes?.data?.data;
      // console.log(jobFullfillmentData, 'jobFullfillmentData');

      const interviewRateData = interviewRateRes?.data?.data;
      // console.log(interviewRateData, 'interviewRateData');

      const offeracceptData = offeracceptRes?.data?.data;
      // console.log(offeracceptData, 'offeracceptData');

      const cancelOpenVacancyData = cancelOpenVacancyRes?.data?.data;
      // console.log(cancelOpenVacancyData, 'cancelOpenVacancyData');


      const colors = [
        "#D6ECFF", // Light Blue
        "#E4F9E3", // Light Green
        "#FFEBCB", // Light Orange
        "#DEE5FF", // Soft Indigo
        "#FFD6D6", // Light Rose
        "#D4F1FF", // Ice Blue
        "#E3EEFF", // Pale Sky
        "#F0DEFF", // Light Lavender
        "#E9F8E5", // Minty Green
        "#FFDFF0", // Baby Pink
      ];

      const updatedJobStatData = [
        {
          title: "Total Jobs Posted",
          value: JobSummaryData?.TotalJobsPosted,
          Icon: <WorkOutlineIcon />,
        },
        {
          title: "Total Open Jobs",
          value: JobSummaryData?.TotalOpenJobs,
          Icon: <WorkIcon />,
        },
        {
          title: "Total Job Completed",
          value: JobSummaryData?.TotalClosedJobs,
          Icon: <WorkOffIcon />,
        },
        {
          title: "Total Job Openings",
          value: cancelOpenVacancyData?.TotalOpenVacancies,
          Icon: <PostAddIcon />,
        },
        {
          title: "Total Applications",
          value: JobSummaryData?.TotalApplications,
          Icon: <GroupIcon />,
        },
        {
          title: "Total Hired Candidates",
          value: JobSummaryData?.TotalHiredCandidates,
          Icon: <FlightTakeoffIcon />,
        },
        {
          title: "Offer Letters Accepted",
          value: offeracceptData?.TotalOffersAccepted,
          Icon: <ThumbUpIcon />,
        },
        {
          title: "Offer Acceptance Rate",
          value: `${Number(offeracceptData?.OfferAcceptancePercentage).toFixed(2)}%`,
          Icon: <TrendingUpIcon />,
        },
        {
          title: "Total Attended Interviews",
          value: interviewRateData?.TotalAttendedInterviews,
          Icon: <PendingActionsIcon />,
        },
        {
          title: "Job Fulfillment Rate",
          value:
            jobFullfillmentData?.DeploymentPercentage != null
              ? Number(jobFullfillmentData.DeploymentPercentage)
                .toString()
                .startsWith("0")
                ? `${Number(jobFullfillmentData.DeploymentPercentage).toFixed(
                  2
                )}%`
                : `${parseInt(jobFullfillmentData.DeploymentPercentage)}%`
              : "",
          Icon: <AutoGraphIcon />,
        },
        {
          title: "Interview attendance Rate",
          value:
            interviewRateData?.InterviewAttendancePercentage != null
              ? Number(interviewRateData.InterviewAttendancePercentage)
                .toString()
                .startsWith("0")
                ? `${Number(
                  interviewRateData.InterviewAttendancePercentage
                ).toFixed(2)}%`
                : `${parseInt(
                  interviewRateData.InterviewAttendancePercentage
                )}%`
              : "",
          Icon: <EventAvailableIcon />,
        },
        {
          title: "Offer Acceptance Percentage",
          value:
            offeracceptData?.OfferAcceptancePercentage != null
              ? Number(offeracceptData.OfferAcceptancePercentage)
                .toString()
                .startsWith("0")
                ? `${Number(offeracceptData.OfferAcceptancePercentage).toFixed(
                  2
                )}%`
                : `${parseInt(offeracceptData.OfferAcceptancePercentage)}%`
              : "",
          Icon: <DoneOutlineIcon />,
        },
        {
          title: "Total Cancelled Candidates",
          value: cancelOpenVacancyData?.TotalCancelledCandidates,
          Icon: <CancelIcon />,
        },
        {
          title: "Total Open Vacancies",
          value: cancelOpenVacancyData?.TotalOpenVacancies,
          Icon: <DomainAddIcon />,
        },
      ].map((stat, index) => ({
        ...stat,
        color: colors[index % colors.length],
      }));

      setJobStatData(updatedJobStatData);
    } catch (err) {
      console.error("Error fetching candidate stats:", err);
    }
  };

  const getJobApplications = async () => {
    if (!jobYear) {
      setJobApplicationData([])
      return
    }
    await axiosAPI
      ?.post(`/reports/job-post/month`, { year: jobYear })
      .then((res) => {
        const monthShortNames = {
          January: "Jan",
          February: "Feb",
          March: "Mar",
          April: "Apr",
          May: "May",
          June: "Jun",
          July: "Jul",
          August: "Aug",
          September: "Sept",
          October: "Oct",
          November: "Nov",
          December: "Dec",
        };

        const updatedData = res?.data?.data?.map((item) => ({
          ...item,
          MonthName: monthShortNames[item.MonthName] || item.MonthName,
        }));

        setJobApplicationData(updatedData || []);
      })
      .catch((err) => { });
  };

  const getJobPostStats = async () => {
    try {
      const res = await axiosAPI?.get(`/reports/job-post-stats`);
      setJobPostStats(res?.data?.data || []);
      // console.log(res?.data?.data,'getJobPostStats');

    } catch (err) { }
  };

  const getJobProfStats = async () => {
    await axiosAPI
      ?.get(`/reports/Profession/job-stats`)
      .then((res) => {
        setJobProfStats(res?.data?.data || []);
        // console.log(res?.data?.data,'getJobProfStats');
      })
      .catch((err) => { });
  };

  const getJobClientStats = async () => {
    await axiosAPI
      ?.get(`/reports/client/job-stats`)
      .then((res) => {
        setJobClientStats(res?.data?.data || []);
        // console.log(res?.data?.data,'getJobClientStats');
      })
      .catch((err) => { });
  };

  const getDeployedJobStats = async () => {
    await axiosAPI
      ?.get(`/reports/deployed-job-stats`)
      .then((res) => {
        setDeployedJobStats(res?.data?.data || []);
        // console.log(res?.data?.data,'getDeployedJobStats');
      })
      .catch((err) => { });
  };

  // Staff API 
  const getStaffProcessStats = async () => {
    await axiosAPI
      ?.post(`/reports/Staff-Process-Stats`, {
        RP_Id: processName ? processName : null,
        StaffId: recruitmentProcessStaff ? recruitmentProcessStaff : null,
        Startdate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
        Stage_id: recruitmentStage ? recruitmentStage : null,
      })
      .then((res) => {

        setStaffProcessStats(res?.data?.data || []);
      })
      .catch((err) => { });
  };

  const getRecruitmentStageslist = async (processName) => {

    try {
      const res = await axiosAPI.post(
        `/RecruitmentProcedure/recruitmentstages`,
        {
          procedureID: processName,
        }
      );
      setRecruitmentStageslist(res?.data?.data || []);

    } catch (err) {
      console.error(err);
    }
  };

  const getStaffInterviewScheduled = async () => {
    if (!interviewScheduledStaff || !interviewStatus) {
      setStaffInterviewScheduledList([])
      return
    }

    try {
      const res = await axiosAPI.post(
        `/reports/Staff-Interviewattend-Stats`,
        {
          StaffId: interviewScheduledStaff,
          StatusId: interviewStatus,
        }
      );

      setStaffInterviewScheduledList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffCancelRate = async () => {
    if (!cancellationRateStaff) {
      setStaffCancelRate([])
      return
    };

    try {
      const res = await axiosAPI.post(`/reports/Cancel-rate-staff`, {
        StaffId: cancellationRateStaff,
      });

      setStaffCancelRate(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffOfferStats = async () => {
    if (!offerStatusStaff) {
      setStaffOfferStats([])
      return
    };

    try {
      const res = await axiosAPI.post(`/reports/offer-stats-staff`, {
        StaffId: offerStatusStaff,
      });

      setStaffOfferStats(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getCandidateByStaff = async () => {
    if (!candidateByStaff) {
      setCandidateByStaffList([])
      return
    };

    try {
      const res = await axiosAPI.post(`/reports/Candidate-by-staff`, {
        StaffId: candidateByStaff,
      });

      setCandidateByStaffList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getStatus = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/list`);
      setStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // Use Effects
  useEffect(() => {
    const startYear = 2020;
    const currentYear = new Date().getFullYear();

    const options = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => {
        const year = startYear + i;
        return { label: String(year), value: String(year) };
      }
    );

    setYearOptions(options);

    getJobs();
    getRecruitmentProcedurelist();

    // Client
    getClientData();
    getTopClients();

    // Candidate
    getCandidateStats();
    getCountriesInProgress();
    getCountriesDeployed();
    getProfessionStats();

    // Job
    getJobData();
    getJobPostStats();
    getJobProfStats();
    getJobClientStats();
    getDeployedJobStats();

    // Staff
    getStaff();
    getStatus();
  }, []);

  useEffect(() => {
    getInterviewStats();
  }, [selectedJob]);

  useEffect(() => {
    getClientJobPosted();
  }, [clientYear]);

  useEffect(() => {
    getJobApplications();
  }, [jobYear]);

  useEffect(() => {
    getRecruitmentStageslist(processName);
  }, [processName]);

  useEffect(() => {
    getRecruitmentStageslist(candidateProcessName);
  }, [candidateProcessName]);

  useEffect(() => {
    getCandidateProcess();
  }, [candidateProcessName, recruitmentProcessStartDate, endDate1, candidateRecruitmentStage]);

  useEffect(() => {
    getStaffProcessStats();
  }, [recruitmentProcessStaff, processName, startDate, endDate, recruitmentStage]);

  useEffect(() => {
    getStaffInterviewScheduled();
  }, [interviewScheduledStaff, interviewStatus]);

  useEffect(() => {
    getStaffCancelRate();
  }, [cancellationRateStaff]);

  useEffect(() => {
    getStaffOfferStats();
  }, [offerStatusStaff]);

  useEffect(() => {
    getCandidateByStaff();
  }, [candidateByStaff]);

  // Rendering Tabs
  const renderReportContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <ClientReportView
            clientStatData={clientStatData}
            mostCandidateDeployed={mostCandidateDeployed}
            topClients={topClients}
            NewClientData={NewClientData}
            yearOptions={yearOptions}
            year={clientYear}
            setYear={setClientYear}
          />
        );
      case 1:
        return (
          <CandidateReportView
            candidateStatData={candidateStatData}
            candidateProcessData={candidateProcessData}
            countriesInProgress={countriesInProgress}
            depoyedByCountry={depoyedByCountry}
            professionStats={professionStats}
            interviewStats={interviewStats}
            JobList={JobList}
            selectedJob={selectedJob}
            setSelectedJob={setSelectedJob}
            processList={processList}
            RecruitmentStageslist={RecruitmentStageslist}
            processName={candidateProcessName}
            setProcessName={setcandidateProcessName}
            recruitmentStage={candidateRecruitmentStage}
            setRecruitmentStage={setCandidateRecruitmentStage}
            startDate={recruitmentProcessStartDate}
            setStartDate={setRecruitmentProcessStartDate}
            endDate={endDate1}
            setEndDate={setEndDate1}
          />
        );
      case 2:
        return (
          <JobReportView
            jobStatData={jobStatData}
            jobApplicationData={jobApplicationData}
            deployedJobStats={deployedJobStats}
            yearOptions={yearOptions}
            year={jobYear}
            setYear={setJobYear}
            jobPostStats={jobPostStats}
            jobProfStats={jobProfStats}
            jobClientStats={jobClientStats}
          />
        );

      case 3:
        return (
          <StaffReportView
            data={staffProcessStats}
            processList={processList}
            processName={processName}
            setProcessName={setProcessName}
            staffList={staffList}
            recruitmentProcessStaff={recruitmentProcessStaff}
            interviewScheduledStaff={interviewScheduledStaff}
            cancellationRateStaff={cancellationRateStaff}
            offerStatusStaff={offerStatusStaff}
            candidateByStaff={candidateByStaff}
            setrecruitmentProcessStaff={setrecruitmentProcessStaff}
            setInterviewScheduledStaff={setInterviewScheduledStaff}
            setCancellationRateStaff={setCancellationRateStaff}
            setOfferStatusStaff={setOfferStatusStaff}
            setcandidateByStaff={setcandidateByStaff}
            staffCancelRate={staffCancelRate}
            staffOfferStats={staffOfferStats}
            candidateByStaffList={candidateByStaffList}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            RecruitmentStageslist={RecruitmentStageslist}
            recruitmentStage={recruitmentStage}
            setRecruitmentStage={setRecruitmentStage}
            staffInterviewScheduledList={staffInterviewScheduledList}
            statusList={statusList}
            interviewStatus={interviewStatus}
            setInterviewStatus={setInterviewStatus}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="error"
        textColor="error"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabLabels.map((label, index) => (
          <Tab
            sx={{
              fontFamily: "Geist, sans-serif",
              background: selectedTab == index ? "#006CB8" : "#EBF2FF",
              border: "1px solid lightgrey",
              borderBottom: "4px solid #EAB308",
              color: selectedTab == index ? "white" : "black",
              fontWeight: 500,
              fontSize: `14px`,
              letterSpacing: "1px",
              minWidth: "150px",
              minHeight: "60px",
            }}
            key={index}
            label={label}
          />
        ))}
      </Tabs>

      <Box sx={{ border: "1px solid lightgrey" }}>{renderReportContent()}</Box>

    </Paper>
  );
};

export default Reports;
